import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import JoinHeroSection from './sections/JoinHeroSection';
import JoinExpectSection from './sections/JoinExpectSection';
import JoinCarouselSection from './sections/JoinCarouselSection';
import JoinLocationSection from './sections/JoinLocationSection';
import JoinPastorsCarouselSection from './sections/JoinPastorsCarouselSection';
import FAQSection from '../../sections/FAQSection';

import './JoinPage.scss';

const JoinPage = () => {
    const { t } = useTranslation();

    return (
        <div className="join-page">
            <Helmet>
                <title>{t('seo_join_title')}</title>
                <meta name="description" content={t('seo_join_description')} />
                <meta property="og:title" content={t('seo_join_title')} />
                <meta property="og:description" content={t('seo_join_description')} />
                <meta property="og:type" content="website" />
            </Helmet>
            <Header />
            <JoinHeroSection />
            <JoinExpectSection />
            <JoinCarouselSection />
            <JoinPastorsCarouselSection />
            <FAQSection />
            <JoinLocationSection />
            <Footer />
        </div>
    );
};

export default JoinPage;
